import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { Member } from '@gem/call/CallStore/Member/Member';
import { List } from '@gem/call/Removable/components/List/List';
import { GroupsPlaceholder } from '@gem/components';
import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';
import { SearchInput } from '@gem/ui-kit';

import { CallMemberItem } from '../Shared/CallMemberItem/CallMemberItem';
import { useCallSelectMemberPopupPresenter } from './CallSelectMemberPopup.presenter';
import styles from './CallSelectMemberPopup.styles.m.css';
import { ICallSelectMemberPopup } from './CallSelectMemberPopup.types';

export const CallSelectMemberPopup: FC<ICommonPopupsProps<ICallSelectMemberPopup>> = observer(
  (props) => {
    const { t } = useTranslation();
    const presenter = useCallSelectMemberPopupPresenter(props);

    const listProps = {
      className: styles.list,
      isScrollable: true,
      data: presenter.participants,
      isLoading: false,
      SpinnerComponent: (
        <GroupsPlaceholder
          count={4}
          className={styles.placeholders}
        />
      ),
      keyExtractor: (contact: Member) => contact.userId,
      renderItem: (member: Member) => (
        <CallMemberItem
          userId={member.userId}
          onSelect={(): void => presenter.onMemberClick(member.userId)}
          call={props.params!.call}
        />
      ),
    };

    return (
      <Popup
        title={t('common_participants')}
        isOpened
        handlePrevStep={presenter.goBack}
        onClose={presenter.onClose}
        isHidden={props.popupInstance.isHidden}
      >
        <SearchInput
          className={styles.search}
          onChange={presenter.onChangeSearchValue}
          value={presenter.searchValue}
          placeholder={t('main_menu_search_note')}
        />
        <List {...listProps} />
      </Popup>
    );
  }
);
